import { render } from "./ColumnProperties.vue?vue&type=template&id=1a974568"
import script from "./ColumnProperties.vue?vue&type=script&lang=js"
export * from "./ColumnProperties.vue?vue&type=script&lang=js"

import "./ColumnProperties.vue?vue&type=style&index=0&id=1a974568&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__